const account = {
  confirmAccountTransfer: "Confirm account transfer",
  patientGetsFullControl:
    "By updating this {{ patientTerm }}'s date of birth to 18+, they will take full control of their Fullscript account, and their parent will no longer have access.",
  actionIsNonReversible: "This action is non-reversible.",
  continue: "Continue",
  cancel: "Cancel",
} as const;

export { account };
